import { affiliatePartnersNames } from '../../pages/AffiliatePage/affiliatePartnersData'
import { OffertResponse } from "../prepare.offert.model.dto";

export interface Offert {
    LoanAmountNet: number;
    Instalments: number;
    RRSO: number;
    InstalmentAmount: number;
}

export interface SuccessfulResponse {
    access_token: string;
    expires_in: number;
    token_type: string;
    scope: string;
    email: string;
    requestedAmount: number;
    installments: number;
    instalmentAmount: number | null;
    offert: Offert;
    biillingCompany : string;
    successReturnUrl: string;
    failureReturnUrl: string;
    currentStatus: string;
    workflowId: number;
    affiliatePartnerId: affiliatePartnersNames | null;
}


export interface RecreateSuccesulResponse{
    access_token: string;
    expires_in: number;
    token_type: string;
    scope: string;
    offert: OffertResponse;
    billingCompany: string;
    phoneNumber: string;
    email: string;
    successReturnUrl: string;
    failureReturnUrl: string;
    workflowId: number
}

export function OffertCamelCase(offert : Offert) : OffertResponse{
    return {
        instalmentAmount: offert.InstalmentAmount,
        rrso : offert.RRSO,
        loanAmountNet : offert.LoanAmountNet,
        instalments: offert.Instalments,
    }
}